import { isDev } from "./utils";

export const WP_JSON_URL = isDev()
    ? "https://keelmind.dev.onpressidium.com/wp-json/wp/v2/"
    : "https://keelmind.onpressidium.com/wp-json/wp/v2/";
